export default "/assets/images/rookie-hero.png?a68dde9a0c488a346c4177352c36c055";